/**
 * Speed and Latency - PDF Presentation Configuration (Arabic)
 *
 * Arabic translation of slide-by-slide configuration with:
 * - Page numbers
 * - Pre-scripted narrations for avatar TTS
 *
 * Mirrors the structure of speed-latency.js exactly.
 */

export const speedLatencyPresentation = {
  // Google Drive PDF - use uc?export=download format for react-pdf
  // Note: Google Drive may have CORS issues. For reliable PDF loading, consider hosting on S3.
  // PDF stays in English per ARBC-03
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/5G.pdf',

  slides: [
    {
      page: 1,
      title: '\u0627\u0644\u0633\u0631\u0639\u0629 \u0648\u0632\u0645\u0646 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629',
      narration: `\u0644\u0646\u062A\u062D\u062F\u0651\u062B \u0639\u0646 \u0627\u0644\u0633\u0631\u0639\u0629 \u0648\u0632\u0645\u0646 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629\u060C   \u0648\u0647\u0645\u0627 \u0645\u0646 \u0623\u0647\u0645 \u062E\u0635\u0627\u0626\u0635 \u0623\u062F\u0627\u0621 5G.

\u0639\u0631\u0636 \u0627\u0644\u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0631\u062F\u062F\u064A \u0647\u0648 \u0643\u0645\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062F\u0641\u0642 \u0641\u064A \u0622\u0646 \u0648\u0627\u062D\u062F\u060C   \u0643\u0639\u0631\u0636 \u0627\u0644\u0623\u0646\u0628\u0648\u0628.

\u0632\u0645\u0646 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0647\u0648 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u063A\u0631\u0642\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0645\u0646 \u0627\u0644\u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644\u060C   \u0623\u064A \u0627\u0644\u062A\u0623\u062E\u064A\u0631.

\u064A\u0642\u0644\u0651\u0644 5G \u0632\u0645\u0646 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0628\u0634\u0643\u0644 \u0643\u0628\u064A\u0631 \u0648\u064A\u0632\u064A\u062F \u0627\u0644\u0633\u0639\u0629 \u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0640 4G\u060C   \u0644\u0643\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u064A\u0639\u062A\u0645\u062F \u0639\u0644\u0649 \u0627\u0644\u0637\u064A\u0641 \u0648\u062A\u0635\u0645\u064A\u0645 \u0627\u0644\u0634\u0628\u0643\u0629 \u0648\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0646\u0634\u0631.`,
    },
  ],
};

export default speedLatencyPresentation;
